import styled from '@emotion/styled';
import React from 'react';

import Alerts from './alerts';
import CardTypography from './card-typography';
import CheckboxDemo from './checkbox-demo';
import TextFields from './input-fields';
import LeftNav from './left-nav';
import PieGraphDemo from './pie-graph-demo';
import ProjectTableDemo from './project-table-demo';
import QuickActionDemo from './quick-action-demo';
import RadioDemo from './radio-demo';
import TabsDemo from './tabs-demo';

import { LeftNavContextProvider } from '~c/components/base/left-nav';
import Spacer, { spc } from '~c/components/base/spacer';

interface Props {
  className?: string;
}

const DashboardImpl: React.FC<Props> = ({ className }) => {
  return (
    <div className={className}>
      <LeftNavContextProvider>
        <LeftNav />
        <div className="content">
          <TabsDemo />
          <Spacer pb={spc.xs} />
          <PieGraphDemo />
          <Spacer pb={spc.xs} />
          <ProjectTableDemo />
          <Spacer pb={spc.xs} />
          <TextFields />
          <Spacer pb={spc.xs} />
          <CardTypography />
          <Spacer pb={spc.xs} />
          <Alerts />
          <Spacer pb={spc.xs} />
          <RadioDemo />
          <Spacer pb={spc.xs} />
          <CheckboxDemo />
        </div>
        <QuickActionDemo />
      </LeftNavContextProvider>
    </div>
  );
};

export const Dashboard = styled(DashboardImpl)`
  display: flex;

  .content {
    /* Body to get full width between left nav and quick drawer */
    width: 100%;
    /* should not show scrollbar if horizontal width is exceeed */
    overflow: hidden;
    padding: 12px;
    border-radius: 0;
  }
`;
export default Dashboard;
